<template>
  <div
    style="
      width: 100%;
      height: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      margin-top: 10px;
    "
  >
    <ul style="display: flex; padding: 0 10px 0 10px">
      <li
        style="
          flex: 1;
          font-weight: 600;
          font-size: 14px;
          color: rgb(60, 60, 60);
        "
      ></li>
      <el-button
        type="primary"
        :icon="Download"
        link
        @click="state.showAgent = true"
      >
        从税局获取欠费信息
      </el-button>
      <el-button type="warning" link icon="Tickets" @click="onUpdate">
        更新缴款结果
      </el-button>
      <el-button type="warning" link icon="Tickets" @click="onSubmit">
        立即缴款
      </el-button>
      <el-button type="warning" link icon="Tickets" @click="onCancel">
        作废电子票税号
      </el-button>
      <el-button
        type="warning"
        link
        icon="Tickets"
        @click.stop="state.showLog = true"
      >
        操作记录
      </el-button>
    </ul>
    <div class="list-box" style="flex: 1">
      <ul class="list-search">
        <el-space wrap style="flex: 1">
          <el-radio-group v-model="state.params.pay_status" @change="onLoad">
            <el-radio-button>全部</el-radio-button>
            <el-radio-button :value="0">未缴税</el-radio-button>
            <el-radio-button :value="1">已缴税</el-radio-button>
          </el-radio-group>
          <el-date-picker
            v-model="state.params.tax_month"
            type="month"
            placeholder="税款所属期"
            value-format="YYYYMM"
            format="YYYY年M月"
            :clearable="false"
          />
          <el-select
            v-model="state.params.withholding_agent_id"
            placeholder="扣缴义务人"
            style="width: 200px"
          >
            <el-option
              v-for="item in state.withholding_agent_data"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
            <template #footer>
              <el-button size="small" @click="onLoadWithholdingAgent()">
                刷新
              </el-button>
            </template>
          </el-select>
          <el-select
            v-model="state.params.tax_bureau_id"
            placeholder="税局"
            style="width: 200px"
          >
            <el-option
              v-for="item in state.customerData"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
            <template #footer>
              <el-button size="small" @click="onLoadCustomer()">
                刷新
              </el-button>
            </template>
          </el-select>
          <el-dropdown split-button @click="onLoad" type="primary">
            查询
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                  重置
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </el-space>
      </ul>
      <ul class="list-table">
        <el-table
          ref="tableDom"
          :data="state.tableData"
          v-loading="!Array.isArray(state.tableData)"
          element-loading-background="rgba(0, 0, 0, 0.2)"
          :default-sort="{
            prop: state.params.sort_field,
            order:
              state.params.sort_value == 'desc' ? 'descending' : 'ascending',
          }"
          @sort-change="onSortChange"
          @row-click="onRowClick"
        >
          <el-table-column type="selection" width="55" fixed />
          <el-table-column
            prop="withholding_agent_name"
            label="企业名称"
            :formatter="$tab_TextFormat"
          />
          <el-table-column
            prop="tax_bureau_name"
            label="税局"
            :formatter="$tab_TextFormat"
          />
          <el-table-column label="所得类型">
            <template #default="{ row }">
              <c_status
                arrName="taxdeclare_declare_type"
                :value="row.declare_type"
              />
            </template>
          </el-table-column>
          <el-table-column label="欠费状态">
            <template #default="{ row }">
              <text :style="{ color: row.qfzt ? '#f00' : '' }">{{
                row.qfzt ? "已欠费" : "-"
              }}</text>
            </template>
          </el-table-column>
          <el-table-column label="缴款状态">
            <template #default="{ row }">
              <text :style="{ color: row.pay_status ? '#080' : '#f00' }">{{
                row.pay_status ? "已缴款" : "未缴款"
              }}</text>
            </template>
          </el-table-column>
          <el-table-column
            prop="sbyy"
            label="失败原因"
            :formatter="$tab_PriceFormat"
          />
          <el-table-column
            prop="ybtse"
            label="应补(退)缴金额"
            :formatter="$tab_PriceFormat"
          />
          <el-table-column
            prop="znje"
            label="滞纳金"
            :formatter="$tab_PriceFormat"
            align="center"
          />
          <el-table-column
            prop="pay_money"
            label="实际缴款金额"
            :formatter="$tab_PriceFormat"
            align="center"
          />
          <el-table-column
            prop="pay_time"
            label="缴款时间"
            :formatter="$tab_TextFormat"
            align="center"
          />
          <el-table-column
            prop="pay_channel"
            label="缴款渠道"
            :formatter="$tab_TextFormat"
            align="center"
          />
          <el-table-column
            label="操作"
            width="120"
            align="center"
            fixed="right"
          >
            <template #default="{ row }">
              <el-button
                type="primary"
                link
                icon="Upload"
                @click="onSingleSubmit(row)"
              >
                缴款
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <c_page
          :total="state.totalCount"
          :pageIndex="state.params.page"
          :pageSize="state.params.limit"
          @onLoad="
            (page) => {
              state.params.page = page.pageIndex;
              state.params.limit = page.pageSize;
              onLoad();
            }
          "
        />
      </ul>
    </div>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showAgent"
        title="从税局获取欠费信息"
        @close="state.showAgent = false"
      >
        <c_Agent
          v-if="state.showAgent"
          :skssq="state.params.tax_month"
          @close="state.showAgent = false"
          @confirm="onSelectConfirm"
        ></c_Agent>
      </c_popup>
    </transition>
    <el-drawer v-model="state.showLog" title="操作记录" size="70%">
      <c_TaxPayLog></c_TaxPayLog>
    </el-drawer>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  data_customer_select,
  data_taxbureau_select,
  data_withholdingagent_select,
} from "@/http/data";
import {
  taxpay_list,
  taxpay_pay,
  taxpay_update,
  taxpay_cancel,
} from "@/http/taxpay";
import { ElMessage, ElMessageBox, dayjs } from "element-plus";
import c_Agent from "./SelectWithholdingAgent.vue";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
    sort_value: "desc",
    pay_type: 1,
  };
}
export default {
  components: {
    c_Agent,
  },
  setup() {
    const tableDom = ref(null);
    const state = reactive(new InitFormData());
    onMounted(() => {
      state.params.tax_month = dayjs().subtract(1, "month").format("YYYYMM");

      onLoadWithholdingAgent();
      onLoadCustomer();
      onLoadTaxBureau();
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      taxpay_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;

          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //获取客户
    const onLoadCustomer = () => {
      data_customer_select().then((res) => {
        if (res.status == 200) state.customerData = res.data.data?.list;
      });
    };

    //加载扣缴义务人
    const onLoadWithholdingAgent = () => {
      data_withholdingagent_select().then((res) => {
        if (res.status == 200)
          state.withholding_agent_data = res.data.data?.list;
      });
    };

    //加载税局
    const onLoadTaxBureau = () => {
      data_taxbureau_select().then((res) => {
        if (res.status == 200) state.taxbureau_data = res.data.data?.list;
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    //表格行点击事件
    const onRowClick = (row) => {
      tableDom.value.toggleRowSelection(row);
    };

    //从税局更新数据确认事件
    const onSelectConfirm = () => {
      state.showAgent = false;
      onLoad();
    };

    //立即缴款
    const onSingleSubmit = (row) => {
      ElMessageBox.confirm(`你确定立即缴款吗？`, "缴款", {
        dangerouslyUseHTMLString: true,
        confirmButtonText: "立即缴款",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const data = {
          pay_type: 0,
          id: row.id,
        };
        taxpay_pay(data).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            onLoad();
          }
        });
      });
    };

    //批量缴款
    const onSubmit = () => {
      const rows = tableDom.value.getSelectionRows();
      if (rows.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择要操作的数据！",
          grouping: true,
        });
        return false;
      }

      ElMessageBox.confirm(
        `您本次选择了<strong style='color:#1e90ff'>${rows.length}</strong>条数据，是否<strong style='color:#ffa500'>缴款</strong>？`,
        "缴款",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "立即缴款",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        const data = {
          pay_type: 0,
          id: rows.map((m) => m.id).join(","),
        };
        taxpay_pay(data).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            onLoad();
          }
        });
      });
    };

    const onUpdate = () => {
      const rows = tableDom.value.getSelectionRows();
      if (rows.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择要操作的数据！",
          grouping: true,
        });
        return false;
      }

      ElMessageBox.confirm(
        `您本次选择了<strong style='color:#1e90ff'>${rows.length}</strong>条数据，是否立即<strong style='color:#ffa500'>更新已选单位的缴款结果</strong>？`,
        "更新缴款结果",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "立即更新",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        taxpay_update(rows.map((m) => m.id).join(",")).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            onLoad();
          }
        });
      });
    };

    //作废电子税票哦
    const onCancel = () => {
      const rows = tableDom.value.getSelectionRows();
      if (rows.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择要操作的数据！",
          grouping: true,
        });
        return false;
      }

      ElMessageBox.confirm(
        `您本次选择了<strong style='color:#1e90ff'>${rows.length}</strong>条数据，是否立即<strong style='color:#ffa500'>作废其电子税</strong>？`,
        "作废电子税票",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定作废",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        taxpay_cancel(rows.map((m) => m.id).join(",")).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            onLoad();
          }
        });
      });
    };

    return {
      state,
      tableDom,
      onLoad,
      onSortChange,
      onReset,
      onLoadCustomer,
      onLoadWithholdingAgent,
      onLoadTaxBureau,
      onRowClick,
      onSelectConfirm,
      onSingleSubmit,
      onSubmit,
      onUpdate,
      onCancel,
    };
  },
};
</script>
<style scoped></style>
